import type { IGetUserProfileResponse } from '../../../repositories/chats/entities/user_profile/GetUserProfileResponse';
import type { IUserProfile } from '../../../types/userProfile';
import { mapClientInfo } from './mapClientInfo';

export const mapResponse200 = (response: IGetUserProfileResponse): IUserProfile => {
  return {
    clientInfo: mapClientInfo(response.clientInfo),
  };
};
